<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import InboxTable from './InboxTable';


export default {
  page: {
    title: 'Inbox',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, InboxTable },
  data() {
    let $this = this;
    return {
      title: 'Inbox',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Inbox', active: true, },
      ],

      loading: true,
      filters: {
        whereins: {
          website: [],
        },
      },
    }
  },
  created() {
    this.filters.whereins.website = [this.website_id];
  },
  methods: {

  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <InboxTable ref="InboxTable" :changefilters="filters"  @loadchange="(e) => {loading = e;}"></InboxTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
